let index = {
	fixedswapv4: require("./fixedswap.v4.json"),
	ierc20: require("./ierc20token.json"),
};

module.exports = index;
